import { render, staticRenderFns } from "./Fund-FundNameVIew.vue?vue&type=template&id=0d04f257&scoped=true&"
import script from "./Fund-FundNameVIew.vue?vue&type=script&lang=js&"
export * from "./Fund-FundNameVIew.vue?vue&type=script&lang=js&"
import style0 from "./Fund-FundNameVIew.vue?vue&type=style&index=0&id=0d04f257&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d04f257",
  null
  
)

export default component.exports